import { Link } from "react-router-dom";
import styles from "./UserProfile.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { userProfile } from "../../../actions/user";
//Logo
import LogoApp from "../../../styles/pics/logo.png";
//Pic & Icon
import NoProfilePic from "../../../styles/pics/NoProfilePic.svg";
import ArrowGray from "../../../styles/icon/ArrowGray.svg";

//Menu Icons
import WalletIcon from "../../../styles/icon/userprofile/Wallet_light.svg";
import carts_light from "../../../styles/icon/userprofile/carts_light.svg";
import Archive_light from "../../../styles/icon/userprofile/Arhive_light.svg";
import Bell_pin_light from "../../../styles/icon/userprofile/Bell_pin_light.svg";
import buyhistory from "../../../styles/icon/userprofile/buyhistory.svg";
import Chat_all_2_light from "../../../styles/icon/userprofile/Chat_alt_add_light.svg";
import Chat_all_2_light2 from "../../../styles/icon/userprofile/Chat_alt_add_light2.svg";
import FAQ from "../../../styles/icon/userprofile/FAQ.svg";
import File_dock_light from "../../../styles/icon/userprofile/File_dock_light.svg";
import Folder_send_light from "../../../styles/icon/userprofile/Folder_send_light.svg";
import Folder_send_light2 from "../../../styles/icon/userprofile/Folder_send_light2.svg";
import Iconography_Caesarzkn from "../../../styles/icon/userprofile/Iconography_Caesarzkn.svg";
import Key_light from "../../../styles/icon/userprofile/Key_light.svg";
import Lock from "../../../styles/icon/userprofile/Lock.svg";
import MaskGroup from "../../../styles/icon/userprofile/MaskGroup.svg";
import Message_light from "../../../styles/icon/userprofile/Message_light.svg";
import sellhistory from "../../../styles/icon/userprofile/sellhistory.svg";
import Subtract from "../../../styles/icon/userprofile/Subtract.svg";
import User_add_light from "../../../styles/icon/userprofile/User_add_light.svg";
import User_box_light from "../../../styles/icon/userprofile/User_box_light.svg";
import Support from "../../../styles/icon/userprofile/support.svg";
import logouticon from "../../../styles/icon/userprofile/logout.svg";

export default function UserProfile() {
  const dispatch = useDispatch();
  const MenuProfileDatas = [
    {
      link: "/my-profile/my-carts",
      pic: carts_light,
      title: "کارت های بانکی من",
      styles: {
        position: "absolute",
        right: "-5px",
        bottom: "-6px",
      },
    },
    {
      link: "/setting",
      pic: Subtract,
      title: "تنظیمات",
    },
    {
      link: "/my-profile/referral",
      pic: User_add_light,
      title: "دعوت از دوستان",
    },
    {
      link: "/app-guid",
      pic: File_dock_light,
      title: "راهنمای استفاده",
    },
    {
      link: "/my-profile/transactions?f=buy",
      pic: buyhistory,
      title: "تاریخجه خرید من",
      styles: {
        position: "absolute",
        right: "5px",
        top: "2px",
      },
    },
    {
      link: "/my-profile/transactions?f=sell",
      pic: sellhistory,
      title: "تاریخچه فروش من",
      styles: {
        position: "absolute",
        right: "0px",
        top: "0px",
      },
    },
    {
      link: "/record-ticket",
      pic: Message_light,
      title: "ثبت تیکت",
    },
    {
      link: "/my-wallet",
      pic: WalletIcon,
      title: "کیف پول",
      styles: {
        position: "absolute",
        right: "4px",
        top: "0px",
      },
    },
    {
      link: "/",
      pic: Support,
      title: "پشتیبانی",
      styles: {
        position: "absolute",
        right: "4px",
        top: "2px",
      },
    },
    {
      link: "/trades-list",
      pic: Iconography_Caesarzkn,
      title: "قیمت لحظه ای",
    },
    {
      link: "/my-profile/transactions?f=withdraw",
      pic: Folder_send_light,
      title: "تاریخجه برداشت ها",
    },
    {
      link: "/my-profile/transactions?f=deposit",
      pic: Folder_send_light2,
      title: "تاریخجه واریز ها",
    },
    {
      link: "/my-profile/change-pass",
      pic: Key_light,
      title: "تغییر رمز عبور",
      styles: {
        position: "absolute",
        right: "-5px",
        top: "0px",
      },
    },
    {
      link: "/my-profile/increase-balance",
      pic: Chat_all_2_light2,
      title: "افزایش اعتبار",
    },

    {
      link: "/my-profile/decrease-balance",
      pic: Chat_all_2_light,
      title: "برداشت از اعتبار",
    },
    {
      link: "/my-profile",
      pic: MaskGroup,
      title: "تنظیمات پین کد(در نسخه موبایل فعال می شود)",
      styles: {
        position: "absolute",
        right: "4px",
        top: "3px",
      },
    },
    {
      link: "/my-profile/messages",
      pic: Bell_pin_light,
      title: "پیام ها",
      styles: {
        position: "absolute",
        right: "2px",
        top: "0px",
      },
    },
    {
      link: "/faq",
      pic: FAQ,
      title: "سوالات متداول",
    },
    {
      link: "/my-profile/info",
      pic: User_box_light,
      title: "اطلاعات حساب کاربری",
      styles: {
        position: "absolute",
        right: "0px",
        top: "0px",
      },
    },
    {
      link: "/my-profile/transactions",
      pic: Archive_light,
      title: "تاریخجه تراکنش ها",
    },
    {
      link: "/my-profile",
      pic: Lock,
      title: "امنیت(در نسخه موبایل فعال می شود)",
    },
    {
      link: "/logout",
      pic: logouticon,
      title: "خروج",
      styles: {
        position: "absolute",
        right: "0px",
        top: "0px",
      },
    },
  ];
  const userInfo = useSelector((state) => state.fullUserInfo.data_profile);
  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if (!userInfo) dispatch(userProfile());
    }
    return () => (mounted = false);
  }, []);
  return (
    <div className={`${styles.container} font_color_white`}>
      <div className={styles.logo_container}>
        <img src={LogoApp} alt="ArzFi" width={89} height={55} />
      </div>
      <header className={styles.headerStatus_container}>
        <section className={styles.headerStatus_bg_container}>
          <div className={styles.user_name}>{userInfo?.user?.fullname}</div>
          <div className={styles.status_acc}>
            <span>وضعیت:‌ </span>
            <span>سطح ۱</span>
          </div>
          {!userInfo?.user?.documentStatus && (
            <div className={styles.finish_verify_button}>
              <Link to="/my-profile/authentication">تکمیل احراز هویت</Link>
            </div>
          )}
        </section>
        <section className={styles.user_pic}>
          <img src={NoProfilePic} alt="AVATAR" width={75} height={75} />
        </section>
      </header>
      <div className={styles.lists_of_links}>
        <ul>
          {MenuProfileDatas?.map((data) => (
            <li key={data.title}>
              <Link to={data.link}>
                <div className={styles.item_of_list}>
                  <div className={`${styles.item_pic} convertPicToGreen`}>
                    <img src={data.pic} alt="" style={data.styles} />
                  </div>
                  <div className={styles.item_title}>{data.title}</div>
                  <div className={styles.item_arrow_pic}>
                    <img src={ArrowGray} alt="" width={12} height={12} />
                  </div>
                </div>
              </Link>
              <div className={styles.line_bottom}></div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
